import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeContentNavigationItemSkeleton } from "./TypeContentNavigationItem";

/**
 * Fields type definition for content type 'TypeContentNavigation'
 * @name TypeContentNavigationFields
 * @type {TypeContentNavigationFields}
 * @memberof TypeContentNavigation
 */
export interface TypeContentNavigationFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'items' (Items)
     * @name Items
     * @localized false
     */
    items: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeContentNavigationItemSkeleton>>;
}

/**
 * Entry skeleton type definition for content type 'contentNavigation' (ContentNavigation)
 * @name TypeContentNavigationSkeleton
 * @type {TypeContentNavigationSkeleton}
 * @author 0K7KCeiwhzHFr0SzwwpA2r
 * @since 2022-07-28T18:52:24.237Z
 * @version 5
 */
export type TypeContentNavigationSkeleton = EntrySkeletonType<TypeContentNavigationFields, "contentNavigation">;
/**
 * Entry type definition for content type 'contentNavigation' (ContentNavigation)
 * @name TypeContentNavigation
 * @type {TypeContentNavigation}
 * @author 0K7KCeiwhzHFr0SzwwpA2r
 * @since 2022-07-28T18:52:24.237Z
 * @version 5
 */
export type TypeContentNavigation<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeContentNavigationSkeleton, Modifiers, Locales>;

export function isTypeContentNavigation<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeContentNavigation<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'contentNavigation'
}
